import { useQuery } from "@tanstack/react-query";

import { getServiceStatus } from "@app/common/api/apiClient/serviceStatus";

const useServiceStatus = () => {
  const { data: serviceStatus, isLoading } = useQuery({
    queryKey: ["service-status"],
    queryFn: getServiceStatus,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
  });

  return {
    serviceStatus,
    isLoading,
  };
};

export default useServiceStatus;
